module.exports = __webpack_public_path__ + "img/1.35134d39.jpg";